/**
 * ProfileSectionShell Component
 * 
 * Reusable wrapper for profile sections with view/edit toggle pattern
 * Beacons-style: clean view mode with small Edit/Add buttons
 */

import React from 'react';
import EditIconButton from './EditIconButton';

interface ProfileSectionShellProps {
  title: string;
  actionLabel?: string;
  onActionClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

const ProfileSectionShell: React.FC<ProfileSectionShellProps> = ({
  title,
  actionLabel,
  onActionClick,
  children,
  className = '',
}) => {
  return (
    <section className={`bg-white border border-slate-200 rounded-xl shadow-sm p-5 md:p-6 mb-5 md:mb-6 relative ${className}`}>
      <div className="mb-3 md:mb-4 flex items-center justify-between gap-2">
        <h2 className="text-lg md:text-xl font-semibold text-slate-900">{title}</h2>
      </div>
      {onActionClick && actionLabel && (
        <div className="absolute right-4 sm:right-6 top-4 sm:top-6 z-10">
          <EditIconButton onClick={onActionClick} />
        </div>
      )}
      {children}
    </section>
  );
};

export default ProfileSectionShell;
